export default "__VITE_ASSET__8addc3db__"